






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {TipoPessoaRecebedor} from '@/model/resource/TipoPessoaRecebedor'
import {InputTipoPessoaRecebedorSchema} from '@/schema/resource/TipoPessoaRecebedor/InputTipoPessoaRecebedorSchema'

@Component
export default class PersistTipoPessoaRecebedorView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputTipoPessoaRecebedorSchema()
  tipoPessoaRecebedor = new TipoPessoaRecebedor()

  async created() {
    await this.populate()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.tipoPessoaRecebedor.getTipoPessoaRecebedor(id)
    }

    $.await.done('getTipoPessoaRecebedor')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('view.persistTipoPessoaRecebedor.error.nomeEmpty')
    }

    await this.tipoPessoaRecebedor.persistTipoPessoaRecebedor()
    await Helper.successAndPush(
      'system.success.persist',
      '/tipo-pessoa-recebedor/list'
    )
  }
}
